import { render, staticRenderFns } from "./AggiungiVisualizzaTemplatePrenotazioni.vue?vue&type=template&id=4aa7b15f&scoped=true&"
import script from "./AggiungiVisualizzaTemplatePrenotazioni.vue?vue&type=script&lang=js&"
export * from "./AggiungiVisualizzaTemplatePrenotazioni.vue?vue&type=script&lang=js&"
import style0 from "./AggiungiVisualizzaTemplatePrenotazioni.vue?vue&type=style&index=0&id=4aa7b15f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa7b15f",
  null
  
)

export default component.exports